module.exports = __webpack_public_path__ + "img/fgr-3.6202ab83.svg";